export enum DmStateEnum {
	PENDING = 'PENDING',
	DENIED = 'DENIED',
	HIDDEN = 'HIDDEN',
	ACCEPTED = 'ACCEPTED'
}
